import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

export type SettingsTabHowToUse = {
  ariaLabel: string;
  title: string;
  body: string;
  examplesLabel: string;
  examples: string[];
};

export const toStringArray = (value: unknown): string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string')
    ? value
    : [];

export type SettingsTranslationNamespace =
  | 'settings'
  | 'customSkills'
  | 'settings.clientTls'
  | 'settings.mcpServerForm';

export function useSettingsHowToUse({
  translationKey,
  namespace = 'settings',
}: {
  translationKey: string;
  namespace?: SettingsTranslationNamespace;
}): SettingsTabHowToUse {
  const t = useTranslations(namespace);
  const tCommon = useTranslations('common');
  const examples = useMemo(
    () => toStringArray(t.raw(`${translationKey}.examples`)),
    [t, translationKey],
  );

  return useMemo(
    () => ({
      ariaLabel: tCommon('howToUse'),
      title: t(`${translationKey}.title`),
      body: t(`${translationKey}.body`),
      examplesLabel: tCommon('examples'),
      examples,
    }),
    [examples, t, tCommon, translationKey],
  );
}
